import React from 'react';
import { useTranslation } from 'react-i18next';
import { BACK_END_FIELDS } from 'shared/constants';
import { DivA11y } from 'utils/a11y-utils';
import { PlaceholderType } from '../../types';
import Icon from '../Icon';
import { Container, Header, Item, Tag } from './style';

type PlaceholderMenuProps = {
  onClose: () => void;
  initialExpand: boolean;
  placeholders: PlaceholderType[];
  onSelect: (selected: string) => void;
};

const PlaceholderMenu = ({
  onClose,
  initialExpand = false,
  placeholders = [],
  onSelect,
}: PlaceholderMenuProps) => {
  const { t } = useTranslation();
  const containerRef = React.useRef<HTMLDivElement>(null);

  const [maximized, setMaximized] = React.useState<Record<string, boolean>>({});

  React.useEffect(() => {
    if (initialExpand && placeholders && placeholders.length > 0) {
      const max: typeof maximized = {};
      placeholders.forEach((placeholder) => {
        max[placeholder.id] = true;
      });
      setMaximized(max);
    }
    setTimeout(() => containerRef.current?.focus(), 100);
  }, []);

  return (
    <Container
      ref={containerRef}
      tabIndex={0}
      onClick={(e) => e.stopPropagation()}
    >
      <Header>
        <div className="heading">{`${t('placeholder')}`}</div>
        <DivA11y className="close" onClick={onClose} aria-label="close">
          <Icon glyph="close" height={20} width={20} viewBox="0 0 20 20" />
        </DivA11y>
      </Header>
      <div className="pl-menu-items">
        {placeholders.map(
          (item) =>
            item.options && (
              <Item key={item.id}>
                <div className="data">
                  <DivA11y
                    className="accordian-header"
                    onClick={() =>
                      setMaximized({
                        ...maximized,
                        [item.id]: !maximized[item.id],
                      })
                    }
                  >
                    <Icon
                      glyph="arrow-down"
                      height={8}
                      width={8}
                      style={{
                        transition: 'transform 0.2s ease-in',
                        transform: maximized[item.id]
                          ? 'rotate(0deg)'
                          : 'rotate(-90deg)',
                      }}
                    />
                    {item.label && (
                      <div className="group-name">{item.label}</div>
                    )}
                  </DivA11y>
                  {maximized[item.id] && (
                    <div className="group-options">
                      {item.options &&
                        item.options
                          .filter(
                            (tag) =>
                              !BACK_END_FIELDS.includes(tag.id) && tag.id,
                          )
                          .map((option) => (
                            <Tag
                              key={option.id}
                              onClick={() => onSelect(option.placeholder)}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') onClose();
                              }}
                            >
                              {option.name}
                            </Tag>
                          ))}
                    </div>
                  )}
                </div>
              </Item>
            ),
        )}
      </div>
    </Container>
  );
};

export default PlaceholderMenu;
